

import Utils from "../../../utils/Utils";
import EpgDataManager from "../../../AAFPersistenceManager/EpgDataManager";
import RecordingLocalUtil from '../../../utils/RecordingLocalUtil';

let internalCacheMiniEpg = {};

export const getEventsByTimeThreshold = async (groupId, startTimeThreshold = 12, endTimeThreshold = 12, forceDate = false) => {
    
    const startTime = forceDate ? Utils.convertUnixOrFormattedDateToDatesObject(startTimeThreshold)  : Utils.now(true).subtract(startTimeThreshold, 'h');
    const endTime = forceDate ? Utils.convertUnixOrFormattedDateToDatesObject(endTimeThreshold) : Utils.now(true).add(endTimeThreshold, 'h');
    try{
        const startTimeFormatted = `${Utils.formatDatesWithOffset(startTime, 'YYYYMMDDHH')}0000`;
        const endTimeFormatted =`${Utils.formatDatesWithOffset(endTime, 'YYYYMMDDHH')}0000`;
        if(internalCacheMiniEpg[`${groupId}${startTimeFormatted}${endTimeFormatted}`]){
            const data = internalCacheMiniEpg[`${groupId}${startTimeFormatted}${endTimeFormatted}`];
            if(data && Array.isArray(data)){
                for(const x in data){
                    const {id_composite = null, ext_recordable = '0'} = data[x];
                    if(id_composite && ext_recordable === '1'){
                        // Buscando el estatus de la grabación.
                        const recorData = RecordingLocalUtil.get(id_composite);
                        if(recorData && recorData.recording_status && data[x].recording_status){
                            data[x].recording_status = recorData.recording_status;
                        }
                    }
                }
            }
            return data;
        }
        else{
            const eventsApi = await new EpgDataManager().getGroupIdsEventsByTimeWindowApi([groupId],startTimeFormatted,endTimeFormatted) || [];
            const [events = [] ] = eventsApi;
            //Solo se cache un solo canal si es un group_id o startime o endtime diferente se limpia cache
            internalCacheMiniEpg = {};
            internalCacheMiniEpg[`${groupId}${startTimeFormatted}${endTimeFormatted}`] = events;
            return events;
        }
    }
    catch(err){
        console.log('getEventsByTimeThreshold err',err);
    }
    return [];
}

export const getCurrentEventIndexInEvent = (events, forcedEvent = false) => {
    if(Array.isArray(events)){
        return events.findIndex((event)=>{
            if(forcedEvent && forcedEvent.date_begin && forcedEvent.date_end){
                return (forcedEvent.date_begin === event.date_begin && forcedEvent.date_end === event.date_end )
            }
            else return (Utils.nowAsTimestampSeconds() >= event.date_begin && Utils.nowAsTimestampSeconds() <= event.date_end )
        });
    }
    return -1;
}



// WEBPACK FOOTER //
// ./src/components/PersistentMiniEpg/Helpers/EpgEventsUtil.js